import { render, staticRenderFns } from "./transaksi_darah.vue?vue&type=template&id=1c67b3e6&scoped=true"
import script from "./transaksi_darah.vue?vue&type=script&lang=js"
export * from "./transaksi_darah.vue?vue&type=script&lang=js"
import style0 from "./transaksi_darah.vue?vue&type=style&index=0&id=1c67b3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67b3e6",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSelect,QSeparator,QBadge,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSelect,QSeparator,QBadge,QPagination,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
